import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/dashboard",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery,
  endpoints: (builder) => ({
    getUserLogs: builder.query({
      query: () => "/get-logs",
    }),
    getDeletedLists: builder.query({
      query: () => "/get-deleted-lists",
    }),
  }),
});

export const { useGetUserLogsQuery, useGetDeletedListsQuery } = dashboardApi;
